/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  List,
  Radio,
  Input,
  Button,
  Form,
  Spin,
  message,
} from "antd";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import { shallowEqual, useSelector, useDispatch } from "react-redux";

import "./index.scss";
import dashboardAnnouncementIcone from "../../assests/images/dashboard-annonsment.svg";
import dashbordMessageIcon from "../../assests/images/dashbord-message-icon.svg";
import accountBookingArrowIcon from "../../assests/images/arrow.svg";
import calenderIcon from "../../assests/images/calenderIcon.svg";
import trackorder from "../../assests/images/trackorder.svg";

import { dashboardMenuList } from "../../config/dashboard";
import DashbordCard from "./DashbordCard";
import DashboardDayTotal from "./DashboardDayTotal";
import constants from "../../constants/messages";
import { getAccountService } from "../../actionsMethods/cashBookingMethods";
import { APIs, getToken, getPremiseId } from "../../utils/worker";
import axios from "axios";

const token = getToken();
const premiseId = getPremiseId();

function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [currentValueRadio, setCurrentValueRadio] = useState(1);
  const [dataSource, setDataSource] = useState([]);
  const {
    TRACK_ORDER,
    PHONE_NUMBER,
    TRACK_ID,
    ORDER_ID,
    TRACK,
    DAY_TOTAL,
    CASH_CHARGES,
    FREIGHT_CHANGES,
    ANNOUNCEMENT,
  } = constants;

  const [accountDetails, setAccountDetails] = useState();
  const [roles, setRoles] = useState();

  useEffect(() => {
    navigate("/dashboard", { state: { test: "test" } });
  }, []);

  const getpremiseResponse = useSelector(
    (state) => state?.appReducer?.getCpPremiseReducer,
    shallowEqual
  );

  const { fetching, result } = getpremiseResponse;

  const checkNumbervalue = (event) => {
    if (!/^[0-9]*\.?[0-9]*$/.test(event.key) && event.key !== "Backspace") {
      return true;
    }
  };

  const onFinish = (values) => {
    // message.success("Submit success!");
    navigate(`/manifest-tracker/${values?.Input}`);
    // navigate(`/manifest-tracker/${22300000371}`);
  };

  const radioData = [
    { radioName: PHONE_NUMBER, value: 1 },
    { radioName: TRACK_ID, value: 2 },
    { radioName: ORDER_ID, value: 3 },
  ];

  useEffect(() => {
    setAccountDetails(JSON.parse(localStorage.getItem("userinfo")));
    setRoles(JSON.parse(localStorage.getItem("userinfo")).roles);
    //disableBackButton();
  }, []);
  // let a = true;
  // if (a) {
  //   history.pushState(null, null, location.href);
  //   window.onpopstate = function (event) {
  //     history.go(1);
  //   };
  // }

  // const validtedFunctoin = (awb) => {
  //   navigate(`/manifest-tracker/${awb}`);
  // };

  useEffect(() => {
    if (accountDetails !== undefined) {
      dispatch(getAccountService(accountDetails?.username));
    }
  }, [accountDetails]);

  useEffect(() => {
    if (!fetching) {
      localStorage.setItem(
        "permises",
        JSON.stringify(result, getpremiseResponse?.result?.premises?.stateCode)
      );
    }
  }, [getpremiseResponse]);

  useEffect(() => {
    getAnnouncements();
  }, []);

  const getAnnouncements = async () => {
    try {
      let response = await axios.get(
        `${APIs.baseURL}/broadcast-service/v1/broadcasts/show`,
        {
          headers: {
            Authorization: token,
            "SMCS-PREMISE-ID": premiseId.split("Bearer ")[1],
          },
        }
      );
      setDataSource(response.data);
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
  const lengthCheck =
    currentValueRadio == "1"
      ? 10
      : currentValueRadio == "2"
      ? 14
      : currentValueRadio == "3"
      ? 12
      : "";

  return (
    <div className="dashboard-container">
      <Spin spinning={fetching}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <div className="dashboardHeading">Dashboard</div>

          <Row gutter={[32, 32]} className="dashboard-container-row">
            <Col
              className="dashboard-container-col"
              xl={16}
              lg={16}
              md={24}
              sm={12}
              xs={24}
            >
              <Row>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="dashboard-container-col-innercol"
                >
                  <div className="">
                    <div className="dashboard-container-col-innercol-trackOrder">
                      <img className="trackOrderImg" src={trackorder} />
                      <span className="dashboard-container-col-innercol-trackOrder-name">
                        {" "}
                        {TRACK_ORDER}
                      </span>
                    </div>
                    <div className="dashboard-container-col-div">
                      <div>
                        <div>
                          <Radio.Group
                            className="dashboard-container-col-radio-grp"
                            onChange={(e) => {
                              setCurrentValueRadio(e.target.value);
                            }}
                            value={currentValueRadio}
                          >
                            {radioData.map((item) => (
                              <Radio
                                className="dashboard-container-col-radio-grp-radiobtn"
                                value={item.value}
                                key={item.value}
                              >
                                <span
                                  className={
                                    currentValueRadio == item.value
                                      ? "dashboard-container-col-radio-grp-radiobtn-name"
                                      : ""
                                  }
                                >
                                  {item.radioName}
                                </span>
                              </Radio>
                            ))}
                          </Radio.Group>
                        </div>
                      </div>
                      <div
                        className="dashboard-container-col-div-inputbtn"
                        style={{
                          display: "flex",

                          columnGap: "10px",
                        }}
                      >
                        <div style={{ width: "80%" }}>
                          <Form.Item
                            name="Input"
                            rules={[
                              {
                                // min: lengthCheck,
                                // max: lengthCheck,
                                required: true,
                                message: "Please enter number",
                                validateTrigger: "onSubmit",
                              },
                            ]}
                          >
                            <Input
                              className="dashboard-container-col-div-inputbtn-input"
                              placeholder={
                                currentValueRadio == "1"
                                  ? "Mobile Number"
                                  : currentValueRadio == "2"
                                  ? "Tracking ID"
                                  : currentValueRadio
                                  ? "Order ID"
                                  : ""
                              }
                              onKeyPress={(event) => {
                                if (checkNumbervalue(event)) {
                                  event.preventDefault();
                                }
                              }}
                              maxLength={lengthCheck}
                            />
                          </Form.Item>
                        </div>
                        <div>
                          <Button
                            className="dashboard-container-col-div-inputbtn-btn"
                            type="primary"
                            htmlType="submit"
                            // onClick={() => validtedFunctoin(22002188888124)}
                          >
                            {TRACK}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row gutter={[32, 32]}>
                {dashboardMenuList.map((item, index) => {
                  if (
                    item?.role === "" ||
                    item.role.some((e) => accountDetails?.roles?.includes(e))
                  ) {
                    return (
                      <Col
                        xl={6}
                        lg={8}
                        md={10}
                        sm={12}
                        xs={12}
                        className="cash-booking"
                        key={index}
                        style={{
                          cursor:
                            item?.title === "Reports"
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <DashbordCard
                          accountBookingArrowIcon={accountBookingArrowIcon}
                          accountBookingIcon={item.icon}
                          watchIcon={calenderIcon}
                          bookingType={item.title}
                          route={item.route}
                          id="cashBooking"
                        />
                      </Col>
                    );
                  }
                })}
              </Row>
            </Col>
            <Col xl={8} lg={8} md={24} sm={24} xs={24}>
              <Row>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <DashboardDayTotal
                    dayTotal={DAY_TOTAL}
                    cashCharger={CASH_CHARGES}
                    freightCharges={FREIGHT_CHANGES}
                  />
                </Col>
              </Row>
              <Row>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Card
                    size="small"
                    className="dashboard-container-card-div"
                    style={{ height: "380px", marginBottom: "20px" }}
                    title={
                      <div>
                        {" "}
                        <img
                          width="24px"
                          height="24px"
                          className="dashboard-container-card-div-icon"
                          src={dashboardAnnouncementIcone}
                        />
                        <span className="announcement-text">
                          {" "}
                          {ANNOUNCEMENT}{" "}
                        </span>
                      </div>
                    }
                  >
                    <List
                      itemLayout="horizontal"
                      dataSource={dataSource}
                      pagination={
                        dataSource.length > 3
                          ? {
                              pageSize: 3,
                            }
                          : false
                      }
                      renderItem={(item) => (
                        <List.Item>
                          <List.Item.Meta
                            title={
                              <div>
                                {" "}
                                <img
                                  width="29px"
                                  height="29px"
                                  className="dashboard-container-card-div-messageIcon"
                                  src={dashbordMessageIcon}
                                />
                                <span
                                  className="listTitle"
                                  style={{
                                    textTransform: "capitalize",
                                    color:
                                      item.priorityType === "HIGH"
                                        ? "#C40000"
                                        : item.priorityType === "MEDIUM"
                                        ? "#DF8100"
                                        : "#179503",
                                  }}
                                >
                                  {item.title}
                                </span>
                              </div>
                            }
                            description={
                              <div>
                                <span className="listDiscription">
                                  {item.validFrom + " - " + item.validTo}
                                </span>
                              </div>
                            }
                          />
                        </List.Item>
                      )}
                    />
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
}
Dashboard.propTypes = {
  data1: PropTypes.number,
};

export default Dashboard;
